import { authHeader, handleResponse } from '../helpers';
export const DamageRptService = {
    fetchDamageData   
};

function fetchDamageData(data) {
    const requestOptions = {
        method: 'POST',
        headers: authHeader(),
        body: JSON.stringify(data)
    };

    return fetch(`${process.env.REACT_APP_API_URL}DamageRpt/GetDamageReport`, requestOptions)
        .then(handleResponse);
}